export const blockIconsHouseholdEnergySavingsLeafNew = (
	<span className='material-symbols-outlined'>energy_savings_leaf</span>
);
